import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { ModalTemplate, Button, ReduxFormHiddenInput } from 'components';
import { Dropdown, Label } from 'semantic-ui-react';

import { reduxForm } from 'redux-form';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTagTargetDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      errorMessage,
      tagDataArray,
      deleteTagNoArray,
      onDeleteTagTarget,
      onToggleModal,
      handleChangeModalTag
    } = this.props;
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagAdd-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagTargetDelete_1', defaultMessage: '태그 일괄 삭제' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagTargetDelete_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} loading={isClicked} onClick={onDeleteTagTarget}>
              {defineMessages(formatMessage({ id: 'ModalTagTargetDelete_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <div className={cx('message-header')}>
            {defineMessages(
              formatMessage({ id: 'ModalTagTargetDelete_4', defaultMessage: '삭제할 태그를 선택하세요.' })
            )}
          </div>
          <div className={cx('input-parent')}>
            <Dropdown
              className={cx('tagTarget-dropdown', 'mt-10')}
              placeholder={defineMessages(
                formatMessage({ id: 'ModalTagTargetDelete_5', defaultMessage: '태그를 입력하세요' })
              )}
              name="deleteTagTarget"
              fluid
              multiple
              error={!!errorMessage}
              search
              selection
              autoFocus
              icon={null}
              options={tagDataArray}
              onChange={handleChangeModalTag}
              renderLabel={(label, index) => ({
                className: label.data.color,
                content: label.text
              })}
            />
            <div className={cx('dropdown-arrow')} />
            {!!errorMessage && (
              <Label className={cx('pointing-label')} basic pointing>
                {errorMessage}
              </Label>
            )}
            {/* {errorMessage && <div className={cx('color-red mt-10')}>{errorMessage}</div>} */}
          </div>
        </div>
        <ReduxFormHiddenInput name="tagNoArray" />
      </ModalTemplate>
    );
  }
}

ModalTagTargetDelete.propTypes = {
  visible: PropTypes.bool,
  onDeleteTagTarget: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      tagNoArray: props.deleteTagNoArray
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTagTargetDelete', enableReinitialize: true })(injectIntl(ModalTagTargetDelete))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTagTargetDelete.js